import React from "react";
import { Button, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { useAppSelector } from "@/utils";
import ShebaCard from "./ShebaCard";

interface SingleIBANCardProps {
  sheba: string;
  onEdit: () => void;
}

const SingleIBANCard: React.FC<SingleIBANCardProps> = ({ sheba, onEdit }) => {
  const { t } = useAppTranslation();
  const isUserSettlement = useAppSelector((state) => state.user.isSettlement);

  return (
    <div>
      <div className="lg:tw-w-1/2">
        <ShebaCard sheba={sheba} status="active" />
        <Button
          onClick={isUserSettlement ? undefined : onEdit}
          disabled={isUserSettlement}
          className="tw-text-blue-600 tw-mt-6 tw-w-full md:tw-w-fit"
        >
          {t("profile.bank.edit")}
        </Button>
      </div>

      <div className="tw-bg-gray-50 tw-mt-2 tw-rounded-lg tw-px-0 md:tw-mt-6 md:tw-p-4">
        <Typography.Text className="tw-text-gray-700 tw-whitespace-pre-line tw-text-sm">
          {t("profile.bank.fullInformationalText")}
        </Typography.Text>
      </div>
    </div>
  );
};

export default SingleIBANCard;
